import React, { useState, useEffect } from 'react';
import { BiArrowBack } from 'react-icons/bi';
import { FaArrowRightLong } from 'react-icons/fa6';
import settings from '../../data/settings';

const BackButton = (props) => {
  const [backLabelText, setBackLabelText] = useState(settings.back_label_text);
  const [arrowColor, setArrowColor] = useState('fff');

  const [navigationContentAlignment, setNavigationContentAlignment] =
    useState('left');

  useEffect(() => {
    setBackLabelText(settings.back_label_text);

    setArrowColor(settings.colors.link_hover_color);

    // Customizing navigation content alignment
    if (settings.alignment.navigation_content === 'left') {
      setNavigationContentAlignment('left');
    }
    if (settings.alignment.navigation_content === 'center') {
      setNavigationContentAlignment('center');
    }
    if (settings.alignment.navigation_content === 'right') {
      setNavigationContentAlignment('right');
    }
  }, []);

  return (
    <div
      className='flex flex-row justify-start gap-2 text-[12px] hover:cursor-pointer viergrad-custom-menu-font-regular'
      onClick={props.onClick}
      style={{
        maxWidth: '3.75rem',
        display: 'flex',
        flexDirection:
          navigationContentAlignment === 'right'
            ? 'row-reverse'
            : navigationContentAlignment === 'left'
            ? 'row'
            : 'row',
        justifyContent:
          navigationContentAlignment === 'right'
            ? 'space-between'
            : navigationContentAlignment === 'left'
            ? 'space-between'
            : 'center',
        paddingLeft: navigationContentAlignment === 'left' ? '1rem' : '0',
      }}
    >
      <div className='-ml-1' style={{ color: arrowColor, paddingTop: '3.5px' }}>
        {navigationContentAlignment === 'left' ||
        navigationContentAlignment === 'center' ? (
          <BiArrowBack />
        ) : (
          <FaArrowRightLong />
        )}
      </div>
      <div className='viergrad-custom-menu-font-regular'>
        {backLabelText.toUpperCase()}
      </div>
    </div>
  );
};

export default BackButton;
